import React from 'react';
import { useHistory } from 'react-router-dom';
import Wrapper, { Menu } from './style';

const Index = (props) => {
  const history = useHistory();
  const {
    menus = [],
    setSelectedMenu,
    selectedMenu = 0,
    withURL,
    className,
    additionalComponent,
    menuColor = 'default',
    menuBorderRadius,
    menuPadding,
    menuMinWidth,
    style,
  } = props;

  return (
    <Wrapper className={className || ''} style={style}>
      <div>
        {menus.map((item) => {
          return (
            <Menu
              menuColor={menuColor}
              menuBorderRadius={menuBorderRadius}
              menuPadding={menuPadding}
              menuMinWidth={menuMinWidth}
              key={item?.value}
              onClick={() => {
                if (withURL) {
                  history.push(item.value);
                  setSelectedMenu(item.value);
                } else {
                  setSelectedMenu(item.value);
                }
              }}
              className={` ${selectedMenu === item?.value ? 'active' : ''}`}
            >
              {item?.label}
            </Menu>
          );
        })}
      </div>
      {additionalComponent && additionalComponent}
    </Wrapper>
  );
};

export default Index;
